<template>
  <ms-dynamic-popup
    title="Tham số in chứng từ"
    classTitle="report-param-title"
    :width="700"
    dockPosition="right"
    @beforeOpen="beforeOpen($event, close)"
    @beforeClose="beforeClose"
    classDetail="report-param-c202aNSND112020-withBankAccount"
    @shortkeyAction="shortkeyAction"
    :name="'C202aNSND112020_WithBankAccount_Offline'"
    ><template v-slot:icon>
      <a
        class="button icon24 ic-question mr-2"
        v-tooltip="'Trợ giúp'"
        shortkey-target="Help"
        target="_blank"
        :href="linkHelp($ms.constant.Help.VoucherReport)"
      ></a>
    </template>
    <template v-slot:content>
      <div class="flex flex-column" style="overflow: auto">
        <div class="report-body flex1 ml-3 mr-3">
          <div class="title-3 flex-row mt-1" @click="changeInfoGenneral">
            <div class="icon-combo--dropdown" :class="[showInfoGenneral ? 'expand' : '']"></div>
            <div class="title-text">Thông tin chung</div>
          </div>
          <div class="report-tab tab-1" v-show="showInfoGenneral">
            <div class="flex-row mt-1" v-if="caseRefType1">
              <div class="flex1">
                <div class="control-title">
                  <label class="label">Tài khoản</label>
                </div>
                <ms-combobox
                  class="flex mt-1"
                  displayField="bank_account"
                  valueField="bank_account"
                  v-model="model.bank_account"
                  v-model:display="model.bank_account"
                  :initText="model.bank_account"
                  :dropdownWidth="600"
                  quickSearch="BankInfoQuickSearch"
                  isReload
                  :data="comboboxDataRemote.bankInfo"
                  :columns="bankInfoColumns"
                  :queryMode="'remote'"
                  :remoteFilter="true"
                  @comboboxLoadData="
                    payload =>
                      onBankInfoComboboxLoadData(payload, null, {
                        dataField: 'bankInfo',
                      })
                  "
                  @selected="
                    ({newData}) => {
                      selectedBank({newData}, this);
                    }
                  "
                ></ms-combobox>
              </div>
              <div class="flex1 ml-2">
                <div class="control-title">
                  <label class="label" title="Chương trình mục tiêu">CTMT</label>
                </div>
                <ms-combobox
                  class="flex mt-1"
                  displayField="project_code"
                  valueField="project_id"
                  v-model="model.project_id"
                  v-model:display="model.project_code"
                  :initText="model.project_code"
                  :dropdownWidth="600"
                  quickSearch="ProjectQuickSearch"
                  :quickSearchParam="quickSearchParam.Project"
                  isReload
                  :data="comboboxDataRemote.project"
                  :columns="projectColumns"
                  :queryMode="'remote'"
                  :remoteFilter="true"
                  @comboboxLoadData="
                    payload =>
                      onProjectCommonComboboxLoadData(
                        customPayloadProject(payload),
                        null,
                        {
                          dataField: 'project',
                        },
                        addDataCombo('project'),
                      )
                  "
                  @selected="
                    ({newData}) => {
                      selectedProject({newData}, this);
                    }
                  "
                ></ms-combobox>
              </div>
            </div>
            <div class="flex-row mt-1">
              <div class="flex1">
                <div class="control-title label">
                  <label class="label">Hình thức thanh toán</label>
                </div>
                <ms-combobox-enum
                  class="flex1 mt-1"
                  :forceSelection="false"
                  enum="PaymentMethod"
                  v-model="model.PaymentMethod"
                  :initText="
                    $ms.format.formatData(model.PaymentMethod, {
                      formatType: 100,
                      enumName: 'PaymentMethod',
                    })
                  "
                  :rules="[
                    {name: $ms.constant.ValidateRule.Required},
                    {name: $ms.constant.ValidateRule.ForceSelection},
                  ]"
                ></ms-combobox-enum>
              </div>
              <div class="d-flex flex1 ml-2">
                <div class="flex1">
                  <div class="control-title">
                    <label class="label" title="Số cam kết chi, Hợp đồng khung">Số CKC, HĐK</label>
                  </div>
                  <ms-input v-model="model.contract_template" :maxLength="50" :trimModel="true" class="mt-1"></ms-input>
                </div>
                <div class="flex1 ml-2">
                  <div class="control-title">
                    <label class="label" title="Số cam kết chi, Hợp đồng thực hiện">Số CKC, HĐTH</label>
                  </div>
                  <ms-input v-model="model.contract_perform" :maxLength="50" :trimModel="true" class="mt-1"></ms-input>
                </div>
              </div>
            </div>
            <div class="flex-row mt-1">
              <div class="flex-column flex1">
                <div class="flex-row">
                  <ms-checkbox label="Phát hành séc" v-model="model.use_sec" class="mb-1 left"></ms-checkbox>
                </div>
                <div class="flex-row">
                  <ms-input v-model="model.add_sec_info" :maxLength="255" :disabled="!model.use_sec"></ms-input>
                </div>
              </div>
              <div class="flex-column flex1 ml-2">
                <div class="flex-row">
                  <ms-checkbox label="Thông tin bổ sung" v-model="model.use_add_info" class="mb-1 left"></ms-checkbox>
                </div>
                <div class="flex-row">
                  <ms-input v-model="model.add_info" :maxLength="255" :disabled="!model.use_add_info"></ms-input>
                </div>
              </div>
            </div>

            <div class="flex-row mt-1" v-if="caseRefType2">
              <div class="mt-1 seperator-line"></div>
            </div>
            <div class="flex-row mt-1" v-if="caseRefType2">
              <div style="width: 324px">
                <div class="control-title">
                  <label class="label">Tên đơn vị nhận tiền</label>
                </div>
                <ms-combobox
                  class="flex mt-1 mr-2"
                  valueField="accounting_object_id"
                  displayField="accounting_object_code"
                  v-model="model.organization_id"
                  v-model:display="model.organization_code"
                  @selected="
                    ({newData}) => {
                      selectedOrganization({newData}, this);
                    }
                  "
                  :initText="model.organization_code"
                  :dropdownWidth="600"
                  :data="comboboxDataRemote.organization"
                  :columns="accountingObjectCustomColumns"
                  :queryMode="'remote'"
                  :remoteFilter="true"
                  @comboboxLoadData="
                    payload =>
                      onAccountingObjectComboboxLoadData(payload, null, {
                        dataField: 'organization',
                      })
                  "
                ></ms-combobox>
              </div>
              <div class="flex2 ml-2">
                <div class="control-title">
                  <label class="label">&nbsp;</label>
                </div>
                <ms-input class="mt-1" v-model="model.organization_name" :maxLength="255" :disabled="true"></ms-input>
              </div>
            </div>
            <div class="flex-row mt-1" v-if="caseRefType2">
              <div style="width: 324px">
                <div class="control-title">
                  <label class="label">Người nhận tiền</label>
                </div>
                <ms-combobox
                  class="flex mt-1 mr-2"
                  valueField="accounting_object_id"
                  displayField="accounting_object_code"
                  v-model="model.accounting_object_id"
                  v-model:display="model.accounting_object_code"
                  @selected="
                    ({newData}) => {
                      selectedAccountingObject({newData}, this);
                    }
                  "
                  :initText="model.accounting_object_code"
                  :dropdownWidth="600"
                  :data="comboboxDataRemote.accountingObject"
                  :columns="accountingObjectCustomColumns"
                  :queryMode="'remote'"
                  :remoteFilter="true"
                  @comboboxLoadData="
                    payload =>
                      onAccountingObjectComboboxLoadData(payload, null, {
                        dataField: 'accountingObject',
                      })
                  "
                ></ms-combobox>
              </div>
              <div class="flex2 ml-2">
                <div class="control-title">
                  <label class="label">&nbsp;</label>
                </div>
                <ms-input
                  class="mt-1"
                  v-model="model.accounting_object_name"
                  :maxLength="255"
                  :disabled="true"
                ></ms-input>
              </div>
            </div>
          </div>
          <div class="title-3 flex-row mt-1" @click="changeKBNNGhi">
            <div class="icon-combo--dropdown" :class="[showKBNNGhi ? 'expand' : '']"></div>
            <div class="title-text" title="Kho bạc nhà nước ghi">KBNN ghi</div>
          </div>
          <div class="report-tab tab-3" v-show="showKBNNGhi">
            <div class="flex-column mt-1">
              <div class="flex-row flex1">
                <div class="flex1">
                  <div class="control-title">
                    <label class="label" title="Nợ tài khoản">Nợ TK</label>
                  </div>
                  <ms-input v-model="model.debit_account_1" :maxLength="20" class="mt-1"></ms-input>
                </div>
                <div class="flex1 ml-2">
                  <div class="control-title">
                    <label class="label" title="Có tài khoản">Có TK</label>
                  </div>
                  <ms-input v-model="model.credit_account_1" :maxLength="20" class="mt-1"></ms-input>
                </div>
                <div class="flex1 ml-2">
                  <div class="control-title">
                    <label class="label" title="Nợ tài khoản">Nợ TK</label>
                  </div>
                  <ms-input v-model="model.debit_account_2" :maxLength="20" class="mt-1"></ms-input>
                </div>
                <div class="flex1 ml-2">
                  <div class="control-title">
                    <label class="label" title="Có tài khoản">Có TK</label>
                  </div>
                  <ms-input v-model="model.credit_account_2" :maxLength="20" class="mt-1"></ms-input>
                </div>
              </div>
            </div>
            <div class="flex-column mt-1">
              <div class="flex-row flex1">
                <div class="flex2 flex-row">
                  <div class="flex1">
                    <div class="control-title">
                      <label class="label" title="Nợ tài khoản">Nợ TK</label>
                    </div>
                    <ms-input v-model="model.debit_account_3" :maxLength="20" class="mt-1"></ms-input>
                  </div>
                  <div class="flex1 ml-2">
                    <div class="control-title">
                      <label class="label" title="Có tài khoản">Có TK</label>
                    </div>
                    <ms-input v-model="model.credit_account_3" :maxLength="20" class="mt-1"></ms-input>
                  </div>
                </div>
                <div class="flex2 ml-2">
                  <div class="control-title">
                    <label class="label" title="Mã địa bàn hành chính">Mã ĐBHC</label>
                  </div>
                  <ms-input v-model="model.tax_payer_organization_code" :maxLength="20" class="mt-1"></ms-input>
                </div>
              </div>
            </div>
          </div>
          <div class="title-3 flex-row mt-1" @click="changeShowDisplay">
            <div class="icon-combo--dropdown" :class="[showDisplay ? 'expand' : '']"></div>
            <div class="title-text">Cách hiển thị</div>
          </div>
          <div class="report-tab tab-4" v-show="showDisplay">
            <div class="flex-row mt-1">
              <ms-checkbox label="Cỡ chữ" v-model="model.has_font_size" class="left"></ms-checkbox>
              <div class="ml-2" style="width: 70px">
                <ms-number
                  v-model="model.font_size"
                  :max="12"
                  :min="6"
                  :step="1"
                  spin
                  :disabled="!model.has_font_size"
                ></ms-number>
              </div>
            </div>
            <div class="flex-row mt-1" v-if="false">
              <div class="seperator-line tab-3"></div>
            </div>
            <div class="flex-row mt-1">
              <ms-checkbox
                class="flex1 left"
                label="Cộng gộp các bút toán giống nhau"
                v-model="model.is_summary_same"
                v-if="false"
              ></ms-checkbox>
              <!-- ml-2 -->
              <ms-checkbox
                class="flex1 left"
                label="Không lặp lại thông tin trùng nhau"
                v-model="model.not_repeat_duplicate"
              ></ms-checkbox>
            </div>
            <div class="flex-row mt-1" v-if="false">
              <ms-checkbox
                class="flex1 left"
                label="Lặp lại tiêu đề và chữ ký ở mỗi trang"
                v-model="model.repeat_title_signature"
              ></ms-checkbox>
              <ms-checkbox
                class="flex1 ml-2"
                label="Trang sau hạ thấp 1/4 trang"
                v-model="model.lower_aquater_page"
                :disabled="model.repeat_title_signature"
              ></ms-checkbox>
            </div>
            <div class="flex-row mt-1" v-if="false">
              <div class="flex1 align-center flex-row">
                <div>Số dòng hiển thị trên 1 trang</div>
                <div class="ml-2" style="width: 70px">
                  <ms-number
                    v-model="model.row_per_page"
                    :max="16"
                    :min="1"
                    :step="1"
                    spin
                    :disabled="!model.repeat_title_signature"
                  ></ms-number>
                </div>
              </div>
              <div class="flex1 align-center ml-2 flex-row">
                <div>Số dòng trống hiển thị ở trang cuối</div>
                <div class="ml-2" style="width: 70px">
                  <ms-number
                    v-model="model.add_empty_row"
                    :max="16"
                    :min="0"
                    :step="1"
                    spin
                    :disabled="!model.repeat_title_signature"
                    :rules="[{name: $ms.constant.ValidateRule.Required}]"
                    keepZero
                  ></ms-number>
                </div>
              </div>
            </div>
            <div class="flex-row mt-1">
              <div class="seperator-line tab-3"></div>
            </div>
            <div class="flex-row mt-1">
              <div class="flex1">
                <div class="control-title label">
                  <label class="label">Nội dung thanh toán là</label>
                </div>
                <ms-combobox-enum
                  class="flex1 mt-1"
                  :forceSelection="false"
                  enum="PaymentContent"
                  v-model="model.payment_content"
                  :initText="
                    $ms.format.formatData(model.payment_content, {
                      formatType: 100,
                      enumName: 'PaymentContent',
                    })
                  "
                  selectOnly
                ></ms-combobox-enum>
              </div>
              <div class="flex1 ml-2"></div>
            </div>
            <div class="flex-row mt-1" v-if="false">
              <div class="seperator-line tab-3"></div>
            </div>

            <div class="flex-row mt-1" v-if="false">
              <div class="flex-column flex1">
                <div class="flex-row">
                  <ms-checkbox label="Bổ sung dòng cộng theo" v-model="model.add_row" class="left"></ms-checkbox>
                </div>
                <div class="flex-row mt-1">
                  <div class="flex-row flex1 align-center">
                    <ms-combobox-enum
                      class="flex1"
                      :forceSelection="false"
                      enum="AddGroup"
                      v-model="model.add_group"
                      :initText="
                        $ms.format.formatData(model.add_group, {
                          formatType: 100,
                          enumName: 'AddGroup',
                        })
                      "
                      :disabled="!model.add_row"
                      selectOnly
                    ></ms-combobox-enum>
                    <ms-combobox-enum
                      class="flex1 ml-2"
                      :forceSelection="false"
                      enum="AddShow"
                      v-model="model.add_show"
                      :initText="
                        $ms.format.formatData(model.add_show, {
                          formatType: 100,
                          enumName: 'AddShow',
                        })
                      "
                      :disabled="!model.add_row"
                      selectOnly
                    ></ms-combobox-enum>
                  </div>
                  <div class="flex1 ml-2">
                    <ms-checkbox
                      label="Hiển thị khi có 2 dòng trở lên"
                      v-model="model.show_min_two_row"
                      :disabled="!model.add_row"
                    ></ms-checkbox>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex-row mt-1" v-if="false">
              <div class="seperator-line tab-3"></div>
            </div>
            <div class="flex-row mt-1" v-if="false">
              <div class="flex-column flex1">
                <div class="flex-row">
                  <ms-checkbox
                    label="Hiển thị thêm dòng"
                    v-model="model.show_add_row"
                    class="left"
                    @change="changeShowRow"
                  ></ms-checkbox>
                </div>
                <div class="flex-row mt-1 align-center">
                  <div class="flex-row flex1">
                    <ms-combobox-enum
                      class="flex1"
                      :forceSelection="false"
                      enum="ShowRow"
                      v-model="model.show_row"
                      :initText="
                        $ms.format.formatData(model.show_row, {
                          formatType: 100,
                          enumName: 'ShowRow',
                        })
                      "
                      :disabled="!model.show_add_row"
                      selectOnly
                    ></ms-combobox-enum>
                    <ms-combobox-enum
                      class="flex1 ml-2"
                      :forceSelection="false"
                      enum="AddShow"
                      v-model="model.add_show_row"
                      :initText="
                        $ms.format.formatData(model.add_show_row, {
                          formatType: 100,
                          enumName: 'AddShow',
                        })
                      "
                      :disabled="!model.show_add_row"
                      selectOnly
                    ></ms-combobox-enum>
                  </div>
                  <div class="flex1 ml-2">lên cột nội dung</div>
                </div>
              </div>
            </div>
            <div class="flex-row mt-1 align-center" v-if="false">
              <div>đồng thời hiển thị thêm</div>
              <ms-checkbox
                label="Mã chương"
                v-model="model.show_budget_chapter_code"
                class="ml-2"
                :disabled="!model.show_add_row"
              ></ms-checkbox>
              <ms-checkbox
                label="Mã ngành KT"
                v-model="model.show_branch_KT_code"
                class="ml-2"
                :disabled="!model.show_add_row"
              ></ms-checkbox>
              <ms-checkbox
                label="Mã nguồn NSNN"
                v-model="model.show_soure_NSNN_code"
                class="ml-2"
                :disabled="!model.show_add_row"
              ></ms-checkbox>
            </div>

            <div class="flex-row mt-1 mb-1" v-if="IsDetailbyBudgetProvidence && false">
              <ms-checkbox
                label="Nhóm dữ liệu theo tính chất nguồn và mã dự phòng"
                v-model="model.is_group_budget_provide"
                class="left"
                @change="changeGroupDate"
              ></ms-checkbox>
            </div>
            <div class="flex-row mt-1 mb-1" v-if="false">
              <ms-checkbox
                label="Gộp chung các tính chất nguồn trên một giấy rút"
                v-model="model.is_summary_budget_property"
                class="left"
              ></ms-checkbox>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer="{close}">
      <div class="h-100 flex-between flex1">
        <div></div>
        <div class="d-flex" style="flex-direction: row-reverse">
          <ms-button text="Đồng ý" @click="commandClick($ms.constant.Command.Ok)"></ms-button>
          <ms-button
            text="Hủy"
            type="outline-button"
            v-tooltip="'Hủy (Ctrl + H)'"
            shortkey-target="Cancel"
            hasBorder
            @click="close"
            style="margin-right: 10px"
          ></ms-button>
        </div>
      </div>
    </template>
  </ms-dynamic-popup>
</template>

<script>
import {defineComponent, getCurrentInstance, reactive, ref, onMounted, watch, computed, nextTick} from 'vue';
import baseVoucherReportParam from '@/views/base/baseVoucherReportParam';
import {ModuleContext} from '@/stores/moduleConst';
import {mapGetters} from 'vuex';
import commonFn from '@/commons/commonFunction';
import popupUtil from '@/commons/popupUtil';
import api from '@/apis/report/voucherReportPrintAPI';
import {showError} from '@/commons/globalMessage';
import msGridEditor from '@/components/gridEditor/MsGridEditor.vue';
import {useInforCommons} from '@/views/utility/commons/inforCommons.js';
import {useRemoteCombobox} from '@/setup/remoteCombobox.js';
import {useInitActionCombo} from '../../../../commons/combobox/initActionCombo.js';
import {useComboboxColumns} from '@/commons/combobox/comboboxColumns';
import OperationUtil from '@/commons/operationUtil';
import {usefilterActionCombo} from '@/commons/combobox/filterActionCombo.js';
import DVCFileAPI from '@/apis/dvc/dVCFileAPI.js';
import accountingObjectInfoAPI from '@/apis/di/accountingObjectInfoAPI.js';
import _ from 'lodash';
import {useSortDataVoucherReportData} from '@/views/report/parameters/voucherReport/SortDataVoucherReport/SortDataVoucherReportData.js';
import {ModuleOfflineWork} from '@/stores/moduleConst';

export default defineComponent({
  components: {
    msGridEditor,
  },
  extends: baseVoucherReportParam,
  setup() {
    const {proxy} = getCurrentInstance();
    const comboboxDataRemote = reactive({});
    const model = reactive({
      PaymentMethod: null,
      contract_template: null,
      contract_perform: null,
      use_sec: false,
      add_sec_info: null,
      use_add_info: false,
      add_info: null,
      debit_account_1: null,
      credit_account_1: null,
      debit_account_2: null,
      credit_account_2: null,
      debit_account_3: null,
      credit_account_3: null,
      tax_payer_organization_code: null,
      has_font_size: false,
      font_size: 12,
      is_summary_same: false,
      not_repeat_duplicate: false,
      repeat_title_signature: true,
      lower_aquater_page: false,
      row_per_page: 10,
      add_empty_row: 2,
      payment_content: 'description',
      add_row: false,
      add_group: 'budget_sub_item_code',
      show_min_two_row: false,
      show_add_row: false,
      show_row: 1,
      add_show: 1,
      add_show_row: 1,
      show_budget_chapter_code: false,
      show_branch_KT_code: false,
      show_soure_NSNN_code: false,
      is_group_budget_provide: false,
      organization_code: null,
      organization_name: null,
      organization_address: null,
      accounting_object_code: null,
      accounting_object_name: null,
      project_code: null,
      project_name: null,
      bank_account: null,
      is_summary_budget_property: true,
    });
    const showInfoGenneral = ref(true);
    const showDisplay = ref(true);
    const showKBNNGhi = ref(true);
    const {columnC202a} = useSortDataVoucherReportData();
    const reportIdCommon = 'C202a_ND11';

    const changeShowDisplay = () => {
      showDisplay.value = !showDisplay.value;
    };

    const changeInfoGenneral = () => {
      showInfoGenneral.value = !showInfoGenneral.value;
    };
    const changeKBNNGhi = () => {
      showKBNNGhi.value = !showKBNNGhi.value;
    };
    const {comboboxLoadData} = useRemoteCombobox();
    // cấu hình column dropdown của combo
    const {bankInfoColumns, accountingObjectCustomColumns} = useComboboxColumns();
    const {onProjectCommonComboboxLoadData, onBankInfoComboboxLoadData, onAccountingObjectComboboxLoadData} =
      useInitActionCombo(comboboxDataRemote, comboboxLoadData);

    const projectColumns = [
      {
        title: 'Mã CTMT',
        dataField: 'project_code',
        width: 140,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên CTMT',
        dataField: 'project_name',
        width: 300,
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
      },
    ];
    /**
     * Thực hiện load data
     */
    async function show() {
      // Focus vào ô input đầu tiên của form
      this.focusFirstControl();

      //Cập nhật dữ liệu vào model
      this.bindData({});
    }

    async function bindData(data) {
      data.ref_type = proxy._formParam?.ref_type;
      data.ref_id = proxy._formParam?.ref_id;

      data.$RefType = proxy._formParam?.ref_type;
      data.$ListRefID = proxy._formParam?.ref_id;
      await defaultData(data);
      data.oldSummarySame = data.is_summary_same;
      proxy.super('bindData', baseVoucherReportParam, data);
      if (proxy.caseRefType1) {
        proxy.model.hasChooseProjectParam = true;
      }
    }

    async function defaultData(data) {
      let dbOptions = {...proxy.$store.state.dbOption.dbOptions};
      data.PaymentMethod =
        data.PaymentMethod ||
        ([
          proxy.$ms.constant.RefType.BUPlanWithdrawCash,
          proxy.$ms.constant.RefType.CAReceipt,
          proxy.$ms.constant.RefType.CAReceiptPlanWithdraw,
        ].includes(data.ref_type)
          ? proxy.$ms.constant.PaymentMethod.CashKB
          : proxy.$ms.constant.PaymentMethod.Transfer);

      let voucher = proxy._report.dataVoucher.data || proxy._report.dataModel;
      if (voucher != null) {
        data.contract_template = data.contract_template || voucher.bu_commitment_request_ref_no;
        data.contract_perform = data.contract_perform || voucher.bu_commitment_request_ref_no;
        data.posted_year = voucher.posted_date.getFullYear();
        // Lấy số chứng từ
        data.ref_no = voucher.ref_no;
        // Đơn vị nhận tiền
        if (
          [proxy.$ms.constant.RefType.BADeposit, proxy.$ms.constant.RefType.BUTransferDeposit].includes(
            voucher.ref_type,
          )
        ) {
          data.organization_name = dbOptions.CompanyName;
          data.organization_address = dbOptions.CompanyAdrress;
        }
        if (
          [
            proxy.$ms.constant.RefType.BUPlanWithdrawDeposit,
            proxy.$ms.constant.RefType.BUTransferSalary,
            proxy.$ms.constant.RefType.BUPlanWithdrawTransfer,
            proxy.$ms.constant.RefType.BUTransfer,
            proxy.$ms.constant.RefType.BUTransferPurchase,
            proxy.$ms.constant.RefType.BUTransferFixedAsset,
            proxy.$ms.constant.RefType.BUPlanWithdrawSalaryTransfer,
            proxy.$ms.constant.RefType.BUTreasuryFundTransferInsurancePayment,
            proxy.$ms.constant.RefType.BUTreasuryFundTransferSalary,
          ].includes(voucher.ref_type)
        ) {
          data.organization_name = voucher.accounting_object_name;
          data.organization_address = voucher.accounting_object_address;
        }
        if (
          [proxy.$ms.constant.RefType.CAReceipt, proxy.$ms.constant.RefType.CAReceiptPlanWithdraw].includes(
            voucher.ref_type,
          )
        ) {
          data.accounting_object_receipt = voucher.accounting_object_name;
        }
        // Lấy tài khoản
        if ([proxy.$ms.constant.RefType.BADeposit].includes(voucher.ref_type)) {
          data.accounting_object_bank_account = voucher.bank_account;
          data.accounting_object_bank_name = voucher.bank_name;
        } else if (
          [
            proxy.$ms.constant.RefType.BUTransfer,
            proxy.$ms.constant.RefType.BUPlanWithdrawTransfer,
            proxy.$ms.constant.RefType.BUPlanWithdrawDeposit,
            proxy.$ms.constant.RefType.BUPlanWithdrawSalaryTransfer,
            proxy.$ms.constant.RefType.BUTransferDeposit,
            proxy.$ms.constant.RefType.BUTransferPurchase,
            proxy.$ms.constant.RefType.BUTreasuryFundTransferInsurancePayment,
            proxy.$ms.constant.RefType.BUTransferSalary,
            proxy.$ms.constant.RefType.BUTransferInsurrance,
            proxy.$ms.constant.RefType.BUTransferFixedAsset,
            proxy.$ms.constant.RefType.BUTreasuryFundTransferSalary,
          ].includes(voucher.ref_type)
        ) {
          data.accounting_object_bank_account = voucher.accounting_object_bank_account;
          data.accounting_object_bank_name = voucher.accounting_object_bank_name;
        } else {
          data.accounting_object_bank_account = data.accounting_object_bank_account || '';
          data.accounting_object_bank_name = data.accounting_object_bank_name || '';
        }
      }
      data.add_sec_info = data.add_sec_info || 'Yêu cầu phát hành sec cho';
    }

    function commandClick(command) {
      const me = proxy;
      switch (command) {
        case this.$ms.constant.Command.Ok:
          // validate control
          if (!me.validateComponents()) {
            nextTick(() => {
              me.focusFirstError();
            });
            return;
          }
          commonFn.mask();
          let dataModel = _.cloneDeep(proxy._report.dataModel);
          var dataVoucher = _.cloneDeep(proxy._report.dataVoucher);
          if (dataModel?.Detail?.length > 0) {
            dataModel.Detail = dataModel.Detail.filter(
              x => x.state != proxy.$ms.constant.ModelState.Delete && x.state != proxy.$ms.constant.ModelState.Empty,
            );
            dataVoucher.data = dataModel; // Gắn lại để lấy dữ liệu mới nhất
          }

          popupUtil.show('ReportOfflineDesigner', {
            dataVoucher: dataVoucher,
            param: proxy.model,
            report: proxy._report.report,
            dataModel: dataModel,
          });
          proxy.hide();
          break;
      }
      proxy.pushTrans(command);
    }
    const {extendFilter} = usefilterActionCombo();
    //Param dùng cho form tìm nhanh
    const quickSearchParam = reactive({
      Project: {
        isFilter: true,
        filterFunc: x => !x.inactive && !x.is_parent && x.object_type == 1 && x.project_code != '<< Không chọn >>',
      },
    });
    function customPayloadProject(payload) {
      let filter = JSON.parse(payload?.filter || '[]');
      let selectedNone = {
        Field: 'project_code',
        Operator: '!=',
        Value: '<< Không chọn >>',
      };
      filter.push(selectedNone);

      payload.filter = extendFilter(payload.filter, filter);
      return payload;
    }

    /**
     * Hàm custom thêm Tất cả, Tổng hợp
     */
    const addDataCombo = function (key) {
      let data = [];
      let custom;
      switch (key) {
        case 'project':
          data = [proxy.$ms.constant.SpecialValue.NoneId];
          break;
        default:
          data = [proxy.$ms.constant.SpecialValue.AllId];
      }
      return {
        callBackFn: OperationUtil.addSpecialValue(key, {data, custom}),
      };
    };

    const selectedOrganization = ({newData}, me) => {
      if (newData) {
        me.model.organization_name = newData.accounting_object_name;
        me.model.organization_address = newData.address;

        // Case riêng trường hợp: Tăng TSCĐ từ QLTS.VN, Đánh giá lại TSCĐ từ QLTS.VN, Đánh giá lại TSCĐ
        if (
          [
            proxy.$ms.constant.RefType.FAVoucherIncreament,
            proxy.$ms.constant.RefType.FAVoucherAdjustment,
            proxy.$ms.constant.RefType.FAAdjustment,
          ].includes(me.model.ref_type)
        ) {
          if (newData.is_employee) {
            proxy.model.accounting_object_bank_account = newData.bank_account;
            proxy.model.accounting_object_bank_name = newData.bank_name;
          } else {
            let payload = {};

            payload.skip = 0;
            payload.sort = 'bank_code';
            payload.take = 10;

            payload.sort = 'bank_code';
            payload.column = 'bank_account, bank_code, bank_name';
            payload.columns = 'bank_account, bank_name';
            let extend = [
              {
                Field: 'accounting_object_id',
                Value: newData.accounting_object_id,
              },
            ];
            payload.filter = extendFilter(payload.filter, extend);
            accountingObjectInfoAPI.getComboboxPaging(payload).then(result => {
              if (result && result.length) {
                const dataBinding = result[0];
                proxy.model.accounting_object_bank_account = dataBinding.bank_account;
                proxy.model.accounting_object_bank_name = dataBinding.bank_name;
              } else {
                proxy.model.accounting_object_bank_account = '';
                proxy.model.accounting_object_bank_name = '';
              }
            });
          }
        }
      } else {
        me.model.organization_name = '';
        me.model.organization_address = '';
      }
    };

    const selectedAccountingObject = ({newData}, me) => {
      if (newData) {
        me.model.accounting_object_name = newData.accounting_object_name;
        me.model.identification_number = newData.identification_number;
        me.model.issue_date = newData.issue_date;
        me.model.issue_by = newData.issue_by;
      } else {
        me.model.accounting_object_name = '';
        me.model.identification_number = '';
        me.model.issue_date = '';
        me.model.issue_by = '';
      }
    };

    function changeShowRow() {
      if (model.show_add_row) {
        model.is_group_budget_provide = false;
      }
    }

    function changeGroupDate() {
      if (model.is_group_budget_provide) {
        model.show_add_row = false;
      }
    }

    const {selectedBank} = useInforCommons();
    const selectedProject = ({newData}, me) => {
      if (newData) {
        me.model.project_name = newData.project_name;
      } else {
        me.model.project_name = '';
        me.model.project_code = '';
        me.model.project_id = null;
      }
    };
    const caseRefType1 = computed(() => {
      return [
        proxy.$ms.constant.RefType.CAReceiptPlanWithdraw,
        proxy.$ms.constant.RefType.BADeposit,
        proxy.$ms.constant.RefType.CAReceipt,
        proxy.$ms.constant.RefType.FAVoucherIncreament,
        proxy.$ms.constant.RefType.FAVoucherAdjustment,
        proxy.$ms.constant.RefType.FAAdjustment,
      ].includes(proxy.model.ref_type);
    });

    const caseRefType2 = computed(() => {
      return [
        proxy.$ms.constant.RefType.FAVoucherIncreament,
        proxy.$ms.constant.RefType.FAVoucherAdjustment,
        proxy.$ms.constant.RefType.FAAdjustment,
      ].includes(proxy.model.ref_type);
    });

    const IsDetailbyBudgetProvidence = computed(() => {
      let dbOptions = {...proxy.$store.state.dbOption.dbOptions};
      return dbOptions.IsDetailbyBudgetProvidence;
    });

    /**
     * @private
     * Lấy tham số khi mở form chi tiết
     * */
    function getDetailParameter(formName, mode, defaultData) {
      const me = proxy;

      let param = {
        data: _.cloneDeep(defaultData) || null,
      };

      switch (mode) {
        case me.$ms.constant.FormState.Duplicate:
        case me.$ms.constant.FormState.Edit:
        case me.$ms.constant.FormState.View:
          param.id = proxy._formParam.id;
          break;
      }

      param.mode = mode;
      param.editMode = proxy._formParam.editMode;
      param.submit = proxy._formParam.submit;
      param.hasBindFormData = true;

      me.customDetailParam(param);

      return param;
    }

    /**
     * override gán dữ liệu chung theo ref_type
     * dqdat1 17.04.2023
     */
    function assignFormatRecentData(data, format) {
      let recent = JSON.parse(format);
      if (recent) {
        Object.assign(data, recent.dataRefType);
      }
    }

    return {
      proxy,
      show,
      model,
      comboboxDataRemote,
      showDisplay,
      showKBNNGhi,
      changeShowDisplay,
      changeKBNNGhi,
      bindData,
      commandClick,
      changeInfoGenneral,
      showInfoGenneral,
      caseRefType1,
      caseRefType2,

      onProjectCommonComboboxLoadData,
      onBankInfoComboboxLoadData,
      onAccountingObjectComboboxLoadData,
      bankInfoColumns,
      accountingObjectCustomColumns,
      customPayloadProject,
      addDataCombo,
      selectedAccountingObject,
      selectedOrganization,
      projectColumns,
      changeShowRow,
      changeGroupDate,
      selectedProject,
      selectedBank,
      getDetailParameter,
      IsDetailbyBudgetProvidence,
      assignFormatRecentData,
      reportIdCommon,
      quickSearchParam,
    };
  },
  computed: {
    ...mapGetters({
      postedDate: ModuleContext + '/PostedDate',
    }),
  },
});
</script>
<style lang="scss">
.report-param-c202aNSND112020-withBankAccount {
  .report-body {
    display: flex;
    flex-direction: column;
    .title-3 {
      align-items: center;
      cursor: default;
      font-weight: $font-weight-semi-bold;
      margin-left: -8px;
    }
    .title-3 .icon-combo--dropdown {
      border-radius: 0 4px 4px 0;
      width: $input-height;
      height: $input-height;
      position: relative;

      &:before {
        content: '';
        position: absolute;
        width: $input-height;
        height: $input-height;
        display: inline-block;
        background: transparent url($ms-image-sprites) no-repeat -334px -45px;
        top: 0px;
        left: 0px;
        transform: rotate(270deg);
        transition: all 0.3s ease;
      }
      &.multiple {
        position: sticky;
        top: 0px;
      }

      &.expand {
        &:before {
          transform: rotate(0deg);
        }
      }
    }
    .seperator-line {
      border-top: 1px solid $secondary;
      width: 100%;
      &.tab-3 {
        border-top: 1px solid $secondary-active;
      }
    }
    .control-title {
      font-weight: $font-weight-medium;
    }
  }

  .ms-checkbox {
    &.left {
      margin-left: -4px !important;
    }
    input[type='checkbox']:disabled {
      background-color: $ms-grey;
    }
  }
  .align-center {
    align-items: center;
  }
}
</style>
